export default __webpack_public_path__ + "static/media/create_project.906e787d.svg";